<div class="container mx-auto px-5 lg:px-10">

    <!-- menu -->
    <p-menubar [model]="items()" class="relative z-50 text-md font-medium" styleClass="h-[66px] !px-0 no-list-styling">
        <ng-template pTemplate="start">
            @if (showBfgLogo()) {
            <a [href]="absoluteWebUrlService.getBaseUrl()">
                <img [src]="absoluteMediaUriService.getAbsoluteMediaUri('/img/portal/BFG_FS_%20logo.png')"
                    alt="Bidding For Good Logo" class="h-9 " />
            </a>
            }
        </ng-template>
        <ng-template #item let-item let-root="root">
            <a pRipple class="flex items-center p-menubar-item-link">
                @switch (item.id) {
                @case ("mobileShoppingCart") {
                    <div class="lg:hidden flex justify-center items-center w-full border rounded-2xl border-[var(--p-info-500)]">
                        <app-shopping-cart [auctionId]="id()" [useSmallIcon]="true" [useExtendedDisplay]="true"></app-shopping-cart>
                    </div>
                }
                @case ("mobileSignIn") {
                <button (click)="openLoginModal()"
                    class="block lg:hidden hover:bg-gray-100 text-[var(--p-info-500)] font-mulish w-full h-9 border rounded-2xl border-[var(--p-info-500)]
                    hover:!text-[var(--p-info-600)] hover:!border-[var(--p-info-600)]
                    active:!text-[var(--p-info-700)] active:!border-[var(--p-info-700)]">
                    <fa-icon [icon]="icons.faUser" /> Sign In
                </button>
                }
                @case ("mobileRegister") {
                <button (click)="openRegister()"
                    class="block lg:hidden !bg-[var(--p-primary-500)] !border-[var(--p-primary-500)] 
              hover:!bg-[var(--p-primary-600)] hover:!border-[var(--p-primary-600)] 
              active:!bg-[var(--p-primary-700)] active:!border-[var(--p-primary-700)] !bg-[var(--p-primary-500)] !border-[var(--p-primary-500)] rounded-2xl w-full h-9 !text-[var(--p-text-color-primary)]">
                    <fa-icon [icon]="icons.faUser" /> Register
                </button>
                }
                @case ("mobileSignOut") {
                <button class="block lg:hidden !bg-[var(--p-primary-500)] !border-[var(--p-primary-500)] 
              hover:!bg-[var(--p-primary-600)] hover:!border-[var(--p-primary-600)] 
              active:!bg-[var(--p-primary-700)] active:!border-[var(--p-primary-700)] !bg-[var(--p-primary-500)] !border-[var(--p-primary-500)] w-full text-sm rounded-2xl h-9 !text-[var(--p-text-color-primary)]" (click)="logout()">
                    Sign Out
                </button>
                }
                @default {
                @if (item.icon != null) {
                <fa-icon class="text-[var(--p-info-500)]
                    hover:!text-[var(--p-info-600)]
                    active:!text-[var(--p-info-700)]" [icon]="getIcon(item.icon)" />
                }
                <span class="text-[var(--p-info-500)]
                    hover:!text-[var(--p-info-600)]
                    active:!text-[var(--p-info-700)]">{{ item.label }}</span>
                <i *ngIf="item.items" [ngClass]="['ml-auto pi', root ? 'pi-angle-down' : 'pi-angle-right']"></i>
                }
                }
            </a>
        </ng-template>
        <ng-template pTemplate="end">
            <div class="hidden lg:flex items-center space-x-4">
                @if (showShoppingCart()) {
                    <app-shopping-cart [auctionId]="id()"></app-shopping-cart>
                }
                @if (isAuthenticated()) {
                <button label="Sign out" pButton class="!text-[var(--p-text-color-primary)] rounded-lg w-full text-sm" [rounded]="true" (click)="logout()">
                </button>
                } @else {
                <button (click)="openLoginModal()"
                    class="hover:bg-gray-100 text-[var(--p-info-500)] font-mulish w-32 h-9 border rounded-2xl border-[var(--p-info-500)]
                    hover:!text-[var(--p-info-600)] hover:!border-[var(--p-info-600)]
                    active:!text-[var(--p-info-700)] active:!border-[var(--p-info-700)]">
                    <fa-icon [icon]="icons.faUser" /> Sign In
                </button>
                <button (click)="openRegister()" class="!bg-[var(--p-primary-500)] !border-[var(--p-primary-500)] 
              hover:!bg-[var(--p-primary-600)] hover:!border-[var(--p-primary-600)] 
              active:!bg-[var(--p-primary-700)] active:!border-[var(--p-primary-700)] !rounded-2xl !w-32 h-9 !text-[var(--p-text-color-primary)]">
                    <fa-icon [icon]="icons.faUser" /> Register
                </button>
                }
            </div>


        </ng-template>
    </p-menubar>


    <!-- auction information  -->

    <div *ngIf="showSocial()" id="auction-header" class="hidden lg:block h-[66px]">
        <div class="flex justify-stretch items-center h-full">
            <a [routerLink]="['/auction', homePageData()?.auctionId]" class="flex items-center">
                @if (showOrgLogo()) {
                <div class="w-[100px] h-[50px] flex items-center justify-center overflow-hidden">
                    <img [src]="homePageData()?.orgLogoUrl" [alt]="homePageData()?.orgName + ' Logo'"
                        class="max-w-full max-h-full object-contain" />
                </div>


                }
                <span class=" ml-2 mr-2 text-xs font-semibold tracking-wide text-custom-gray-dark">
                    {{ homePageData()?.auctionName }}
                </span>
            </a>
            <div [ngClass]="{ 'invisible': homePageData()?.isTicketFocusedHomepageEnabled || homePageData()?.eventType == 'TICKET_ONLY'}"
                class="border-l-2 border-blue-200 flex-auto align-middle pl-2 text-xs tracking-wide text-custom-gray-dark">
                <fa-icon [icon]="icons.faCalendarXmark"></fa-icon>
                Auction Ends: {{auctionEndDateFormat()}}
            </div>
            <div *ngIf="showSocialShare()" class="flex items-center gap-2">
                <a (click)="openPopupCenter(facebookShareUrl(), 'popUpWindow', 550, 550)">
                    <fa-icon [icon]="icons.faFacebook"
                        style="color: #0866ff; cursor: pointer; font-size: 24px; margin-right: 10px;"
                        aria-label="Share to Facebook Logo"></fa-icon>
                </a>
                <a [href]="twitterShareUrl()" target="_blank">
                    <fa-icon [icon]="icons.faXTwitter" style="color: black; font-size: 24px; margin-right: 10px;"
                        aria-label="Share to Twitter Logo"></fa-icon>
                </a>
                <a [href]="linkedinShareUrl()" target="_blank">
                    <fa-icon [icon]="icons.faLinkedin" style="color: #0077B5; font-size: 26px; "
                        aria-label="Share to LinkedIn Logo"></fa-icon>
                </a>
            </div>
        </div>
    </div>
</div>